var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUpload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1092 4.16186C13.325 3.94605 13.675 3.94605 13.8908 4.16186L19.4171 9.68818C19.6329 9.90399 19.6329 10.2539 19.4171 10.4697C19.2013 10.6855 18.8514 10.6855 18.6355 10.4697L14.0526 5.8868V17.8158C14.0526 18.121 13.8052 18.3684 13.5 18.3684C13.1948 18.3684 12.9474 18.121 12.9474 17.8158V5.8868L8.36445 10.4697C8.14864 10.6855 7.79873 10.6855 7.58291 10.4697C7.3671 10.2539 7.3671 9.90399 7.58291 9.68818L13.1092 4.16186ZM3.55263 17.2632C3.85784 17.2632 4.10526 17.5106 4.10526 17.8158V22.2368C4.10526 22.6765 4.27993 23.0982 4.59085 23.4091C4.90176 23.7201 5.32346 23.8947 5.76316 23.8947H21.2368C21.6765 23.8947 22.0982 23.7201 22.4091 23.4091C22.7201 23.0982 22.8947 22.6765 22.8947 22.2368V17.8158C22.8947 17.5106 23.1422 17.2632 23.4474 17.2632C23.7526 17.2632 24 17.5106 24 17.8158V22.2368C24 22.9697 23.7089 23.6725 23.1907 24.1907C22.6725 24.7089 21.9697 25 21.2368 25H5.76316C5.03032 25 4.3275 24.7089 3.80931 24.1907C3.29112 23.6725 3 22.9697 3 22.2368V17.8158C3 17.5106 3.24742 17.2632 3.55263 17.2632Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload.396104e8.svg";
export { ForwardRef as ReactComponent };